const guaranteeOptions = {
  GS75: [7, 6, 5],
  V64: [6, 5, 4],
  V65: [6, 5],
  V75: [7, 6, 5],
  V86: [8, 7, 6],
};

export default guaranteeOptions;
